'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'brush';
var width = 384;
var height = 512;
var aliases = [];
var unicode = 'f55d';
var svgPathData = ['M16 64l0 192 352 0 0-192c0-26.5-21.5-48-48-48l-48 0 0 88c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-88-64 0 0 72c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-72L96 16l0 104c0 4.4-3.6 8-8 8s-8-3.6-8-8L80 16 64 16C37.5 16 16 37.5 16 64zm0 208l0 16c0 35.3 28.7 64 64 64l48 0c8.8 0 16 7.2 16 16l0 80c0 26.5 21.5 48 48 48s48-21.5 48-48l0-80c0-8.8 7.2-16 16-16l48 0c35.3 0 64-28.7 64-64l0-16L16 272zM208 448a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z', 'M256 352c-8.8 0-16 7.2-16 16l0 80c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-80c0-8.8-7.2-16-16-16l-48 0c-35.3 0-64-28.7-64-64l0-16 352 0 0 16c0 35.3-28.7 64-64 64l-48 0zm112-96L16 256 16 64c0-26.5 21.5-48 48-48l16 0 0 104c0 4.4 3.6 8 8 8s8-3.6 8-8L96 16l80 0 0 72c0 4.4 3.6 8 8 8s8-3.6 8-8l0-72 64 0 0 88c0 4.4 3.6 8 8 8s8-3.6 8-8l0-88 48 0c26.5 0 48 21.5 48 48l0 192zM80 368l32 0 16 0 0 16 0 64c0 35.3 28.7 64 64 64s64-28.7 64-64l0-64 0-16 16 0 32 0c44.2 0 80-35.8 80-80l0-224c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 288c0 44.2 35.8 80 80 80zm128 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBrush = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;